import React, { memo, useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Row, Col } from "reactstrap";
import { Divider } from "antd";
import { useSelector } from "react-redux";
import { gql, useLazyQuery, useQuery } from "@apollo/client";
import Loader from "../../Loader";
// import SelectGroup from "./SelectGroup";
// import PanelGroup from "./PanelsGroup";
import "./ByPanel.scss";
import { error } from "../../Controllers/toast";
import PannelMapComponent from "./PannelMap";

const GET_PO_GROUPS = gql`
  query GetOptimizers($plant_id: Int!,$date_time: Date,$offset_date: Int) {
    GetOptimizers(plant_id: $plant_id,date_time:$date_time,offset_date:$offset_date) {
      Opt_Group_id
      panelsPerRow
      order_index
      blockgroups {
        Block_Group_Info {
          block_name
          id
        }
        Block_Group_id
      }
      gateway {
        serial_number
        group_data {
          Vline
          Iline
          Temp
          date_time
          Gateway_id
          BatteryCharge
        }
      }
      optimizers {
        PO_id
        serial_number
        order_index
        Last_Production {
          Vo
          Vpv
          Ipv
          Vbat
          Ibat
          Ein
          Temp
          SOC
          date_time
        }
      }
      active_balancer {
        Balancer_id
        serial_number
        Active_Balancer_Data {
          date_time
          Ineutral
          Ineutral_rms
          Vline_neg
          Vline_pos
          Vearth
          Ths
          Tamb
        }
      }
    }
  }
`;

const STRING_BATTERY_INFO = gql`
  query ($plant_id: Int!, $date_time: Date, $offset_date: Int, $Opt_Group_id:Int!) {
    GetStringBatteryInfo(
      plant_id: $plant_id
      Opt_Group_id: $Opt_Group_id
      date_time: $date_time
      offset_date: $offset_date
    ) {
      BatteryCharge
    }
  }
`;


const ByPanel2 = ({ plantId }) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [date_time, setDate_time] = useState(new Date())
  const offset_date = date_time.getTimezoneOffset()

  useEffect(() => {
    setInterval(() => {
      if (date_time.getTime() + 1 * 60 * 1000 < (new Date()).getTime()) {
        // console.log("Time is Passed!!!")
        setDate_time(new Date())
      }
    }, 5 * 60000)

  }, [])

  //   States Section:
  const [PO_groups, setPO_groups] = useState([]);

  const { loading, data, refetch, updateQuery } = useQuery(GET_PO_GROUPS, {
    variables: { plant_id: parseInt(plantId), date_time, offset_date },
    onCompleted: (res) => {
      // console.log(res.GetOptimizers, "is response");
      setPO_groups(res.GetOptimizers);
    },
    onError: (err) => {
      console.log(err);
      error("مشکلی در دریافت اطلاعات رخ داده است!");
    },

    //  notifyOnNetworkStatusChange: true,
    pollInterval: 20000,
    // errorPolicy: "ignore",
  });

  // const [getStringBatteryInfo, { loading: loadingStringBattery }] = useLazyQuery(STRING_BATTERY_INFO, {
  //   onError: (err) => {
  //     console.log(err);
  //   },
  //   onCompleted: (res) => {

  //     console.log(res, "is getStringBatteryInfo");
  //     // setBatteryCharge(res.GetBatteryInfo.BatteryCharge);
  //   },
  // });
  // console.log(loading , data , "is data")
  if (loading && !data) return <Loader />;
  else if (PO_groups.length >= 0 && !loading && data) {
    // console.log("Heyyyyyyyyyyyyyyyyyyy yyyyyyyyyyy");
    // if (temp === 0) {
    //   setInterval(() => {
    //     // startPolling(()=>{

    //     //   setPO_groups([])
    //     // })
    //     // stopPolling((res)=>{
    //     //   console.log(res)
    //     // })
    //     refetch({ plant_id: parseInt(plantId) }).then((res) =>
    //       setPO_groups(res.data.GetOptimizers)
    //     );
    //   }, 30000);
    //   temp = 1;
    // }

    const groupedPOGroups = PO_groups.reduce((acc, PO_group) => {
      const id = PO_group.blockgroups.Block_Group_id;
      if (!acc[id]) {
        acc[id] = [];  // اگر گروه برای این ID وجود ندارد، یک آرایه جدید می‌سازیم
      }
      acc[id].push(PO_group);  // آیتم جدید را به گروه اضافه می‌کنیم
      return acc;
    }, {});


    return (
      <div className="animated fadeIn">
        {
          // Select Group Section :
        }
        {/* <Card>
          <CardHeader>
            <h3 className="">
              {lang_choiced.pages.byPanel.header.title}
            </h3>
            <p className="text-muted font-family-BRoya">
              {lang_choiced.pages.byPanel.header.subTitle}
            </p>

            <SelectGroup PO_groups={PO_groups} lang_choiced={lang_choiced} />
          </CardHeader>
        </Card>

        <Divider /> */}


        {Object.keys(groupedPOGroups).map((groupId, index) => {
          const PO_groups = groupedPOGroups[groupId];
          // console.log(PO_groups ,"is PO_groups")
          return (
            <PannelMapComponent key={index} blockIndex={index} PO_groups={PO_groups} lang_choiced={lang_choiced} plantId={plantId} />
          );
        })}

      </div>
    );
  } else {
    return (
      <div className="animated fadeIn">
        {
          // Select Group Section :
        }
        <Card>
          <CardHeader>
            <h1 className="font-family-BRoya">
              {lang_choiced.pages.byPanel.header.title}
            </h1>
            <p className="text-muted font-family-BRoya">
              {lang_choiced.pages.byPanel.header.subTitle}
            </p>

            {/* <SelectGroup PO_groups={PO_groups} lang_choiced={lang_choiced} /> */}
          </CardHeader>
        </Card>

        <Divider />

        <div>

        </div>
      </div>
    );
  }
};

export default ByPanel2;
